import { updates } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          最新更新
        </h2>
        <div className="relative max-w-[800px] mx-auto">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-12">
                <div className="absolute left-0 top-1.5 w-[30px] h-[30px] md:w-[38px] md:h-[38px] rounded-full bg-primary-100 border-4 border-background-50 flex items-center justify-center z-10">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400 font-mono">{item.date}</span>
                  <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                    item.tag === '上新' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '热播' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '完结' ? 'bg-secondary-100 text-secondary-700' :
                    item.tag === '推荐' ? 'bg-accent-100 text-accent-700' :
                    'bg-foreground-100 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}